<template>
  <div class="app">
    <div class="apphd">
        <img class="ctnbg" src="../assets/img/wallcon.png"/>
        <div class="hdwrap">
          <div class="lgo">
              <img src="../assets/img/logo.png"/>
          </div>
          <a href="https://app.untraoffice.com" class="login">Login Account</a>
        </div>
        <div class="hro">
            <div class="hro-wrp">
                <h3>
                    <span>Efficiency Starts Here: </span>
                    <span>Simplify Office Operations</span>
                </h3>
                <h5>
                    <span>One platform to handle tasks,</span>
                    <span>customers, staff, and beyond</span>
                </h5>
                <div @click="scrollToSection" class="cta">Start free trial</div>
            </div>
        </div>
        <div class="feats">
            <p class="ttl">WHAT WE DO FOR YOU:</p>
            <div class="featwrap">
                <div class="feat">
                    <p>TASK MANAGEMENT</p>
                </div>
                <div class="feat">
                    <div>
                        <p>CRM</p>
                        <p class="small">CUSTOMER RELATIONSHIP MANAGEMENT</p>
                    </div>
                </div>
                <div class="feat">
                    <p>STAFF MANAGEMENT</p>
                </div>
                <div class="feat">
                    <p>REPORTING</p>
                </div>
            </div>
        </div>
    </div>
    <div class="hdnte">
        <div class="nte">
            <p>AFFORDABLE PLANS FOR TEAMS OF EVERY SIZE.</p>
            <div class="cta" @click="scrollToSection">Start free trial</div>
        </div>
    </div>

    <div class="infoctn">
        <h2>Get Ready for the Best Smart Office Operations Experience</h2>
        
        <div class="section">
            <div class="box">
                <div class="boxarr">
                  <img src="../assets/img/arrow.png"/>
                </div>
                <img src="../assets/img/key-person.png" alt="Flaticon Image">
                <h3>Custom Permissions for Roles</h3>
                <p>Define and control access levels with role-based permissions, ensuring team members have the right access to the right tools—boosting security and efficiency.</p>
            </div>
            <div class="box">
              <div class="boxarr">
                <img src="../assets/img/arrow.png"/>
              </div>
              <img src="../assets/img/strategic-alliance.png" alt="Flaticon Image">
              <h3>Customer Relationship Management</h3>
              <p>Track customer interactions, manage contacts, and streamline communication to build stronger relationships and improve customer satisfaction.</p>
            </div>
            <div class="box">
              <img src="../assets/img/meeting.png" alt="Flaticon Image">
              <h3>Task Management</h3>
              <p>Organize, assign, and monitor tasks effortlessly to keep projects on track, deadlines met, and productivity at its peak.</p>
            </div>
        </div>
        
        <div class="section">
            <div class="box">
              <div class="boxarr">
                <img src="../assets/img/arrow.png"/>
              </div>
              <img src="https://designingmedia.com/repay/wp-content/uploads/2022/08/personal-account-icon-2.png" alt="Flaticon Image">
              <h3>Staff Management</h3>
              <p>Simplify employee scheduling, track performance, and manage team workflows—all from one centralized platform.</p>
            </div>
            <div class="box">
              <div class="boxarr">
                <img src="../assets/img/arrow.png"/>
              </div>
              <img src="../assets/img/bell.png" alt="Flaticon Image">
              <h3>Notifications</h3>
              <p>Stay updated with real-time alerts and reminders for important tasks, deadlines, and team updates, ensuring nothing gets overlooked.</p>
            </div>
            <div class="box">
                <img src="../assets/img/organization-structure.png" alt="Flaticon Image">
                <h3>Departments</h3>
                <p>Structure your organization efficiently by grouping staff into departments, streamlining workflows, and improving collaboration within teams.</p>
            </div>
        </div>
    </div>
    <div class="delclm">
        <img class="ctnbg" src="../assets/img/bg1.jpg"/>
        <div class="delnte">
            <div class="delntewrp">
                <h4>BAD DELEGATION <span>STOPS HERE!!!</span></h4>
                <h5>Bad task delegation = Wasted Time = Lost Money</h5>
                <p>Delegate better with UntraOffice Task Management</p>
                <div class="cta" @click="scrollToSection">Start free trial</div>
            </div>
        </div>
    </div>
    <div class="price-list" id="price-list">
      <div class="prc-bg">
        <img src="../assets/img/prc-bg.jpg"/>
      </div>
      <div class="price-list-container">
        <h2 class="title">Affordable Plans That Scale With You</h2>
        <p class="ttl-desc">Choose a plan that grows with your team—smart, simple, and cost-effective</p>
        <div class="price-grid">
          <div v-for="plan in pricingPlans" :key="plan.id" class="price-card" style="width: 33%;flex: none;">
            <div class="prc-top">
              <h3 class="plan-title">{{ plan.name }}</h3>
              <p class="price">{{ plan.price }}</p>
              <p class="dutn">Per Month</p>
            </div>
            <ul class="features-list">
              <li v-for="feature in plan.features" :key="feature">{{ feature }}</li>
            </ul>
            <router-link :to="{name : 'register', params: { package: plan.type }}" class="btn select-btn">
              Start 1 Month free trial
            </router-link>
          </div>
        </div>
      </div>
    </div>
    

    
  </div>
</template>

<script>
import { ref } from 'vue';
export default {
  name: 'DashboardView',
  setup() {
    const pricingPlans = ref([
        {
          id: 1,
          name: "Starter Plan",
          price: "₦7,000",
          features: ["Task Management", "Customer Relationship Management", "Up to 10 Users","Affordable for small businesses"],
          type:"starter"
        },
        // {
        //   id: 2,
        //   name: "Pro",
        //   price: "₦65,000",
        //   features: ["Task Management", "Customer Relationship Management", "Up to 50 Users","Scales as your business grows"],
        //   type:"pro"
        // },
        // {
        //   id: 3,
        //   name: "Enterprise",
        //   price: "₦95,000",
        //   features: ["Task Management", "Customer Relationship Management", "Unlimited Users","Tailored for large-scale operations"],
        //   type:"enterprise"
        // }
      ]);

      function scrollToSection() {
        document.getElementById("price-list").scrollIntoView({ behavior: "smooth" });
      }
    return{
      pricingPlans,scrollToSection
    }
  }
}
</script>
<style>
.login{text-decoration: none; position: absolute; right: 20px; z-index: 2;
  top: 32px; font-weight: bold; color: black;}
</style>

